import React from 'react';
// import { FormControlLabel, FormGroup, Switch as MiuSwitch, SwitchProps } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import MiuSwitch from '@mui/material/Switch';
import { SwitchProps } from '@mui/material/Switch';

export type ISwitchProps = {
    className?: string;
    // id?: string;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (ev?: React.FormEvent<HTMLInputElement>) => void;
    label?: string | React.ReactNode;
    color?: SwitchProps['color'];
    name?: string;
} & Omit<SwitchProps, 'color'>;

const Switch: React.FC<React.PropsWithChildren<ISwitchProps>> = ({ checked = null, onChange = () => { }, disabled = null, label, color, className, name, ...rest }) => {
    return (
        <FormGroup className={className}>
            <FormControlLabel
                disabled={disabled}
                control={<MiuSwitch checked={checked} onChange={onChange} inputProps={{ 'aria-label': 'controlled', name }} color={color} {...rest} />}
                label={label}
            />
        </FormGroup>
    );
};

export default Switch;
